// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"NavigationItem__NavigationItem__lrD-G","Uppercase":"NavigationItem__Uppercase__38FEj","Lowercase":"NavigationItem__Lowercase__7iVTy","active":"NavigationItem__active__1RMRh"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 37
// module chunks = 0